import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=917520b4&"
import script from "./ToolbarButton.vue?vue&type=script&lang=ts&"
export * from "./ToolbarButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports